module.exports = __webpack_public_path__ + "static/media/main-2.a67c2179.png";